import React, { useEffect } from 'react';
import TaxConsultingBoard from './TaxConsultingBoard';
import TaxConsultingCategoryList from './TaxConsultingCategoryList';
import { getTaxConsultingCategory } from '../../../apis/tax-portal/tax-consulting';

const TaxConsulting = (props) => {
  const searchParams = new URLSearchParams(props.location.search);
  const categoryIdx = searchParams.get('categoryIdx');
  const boardIdx = searchParams.get('boardIdx');

  useEffect(() => {
    if (categoryIdx) {
      getTaxConsultingCategory(categoryIdx);
    }
  }, [categoryIdx]);

  return categoryIdx ?
    <TaxConsultingBoard
      {...props}
      categoryIdx={Number(categoryIdx) || null}
      boardIdx={Number(boardIdx) || null}
    />
    :
    <TaxConsultingCategoryList
      {...props}
    />;
};

export default TaxConsulting;